import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

type Props = {
  content?: React.ReactNode;
  sidebar?: React.ReactNode;
  children?: React.ReactNode;
  size: 'small' | 'medium' | 'fullScreen';
  stickySidebar?: boolean;
  className?: string;
};

const ContentLayout: React.FC<Props> = ({ content, sidebar, children, size, stickySidebar, className}) => {
  const contentElement = content || children;
  
  if (!contentElement) {
    return null;
  }
  
  const rootClassNames = classnames(styles['root'], styles[size], className);
  const sidebarWrapperClassNames = classnames(styles['sidebar-wrapper'], {
    [styles['stickySidebar']]: stickySidebar,
  });
  
  return (
    <div className={rootClassNames}>
      {sidebar && (
        <div className={sidebarWrapperClassNames}>
          <div className={styles['sidebar']}>{sidebar}</div>
        </div>
      )}
      <div className={styles['content']}>{contentElement}</div>
    </div>
  );
};

export default ContentLayout;
